import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Config } from '../config/env.config';
import { BaseHttpService } from '../base/_base-http.service';
import { contentHeaders } from 'common/headers';
import * as _ from 'lodash';
import {catchError} from 'rxjs/operators';

@Injectable()
export class LookupsService extends BaseHttpService {

    fetch(lookup: string, search: string): Observable<any> {
        return this.http.get(Config.API + '/lookup/' + lookup + '?search=' + search)

            .pipe(catchError(this.handleError.bind(this)));
    }

}
